import { useMutation } from "@tanstack/react-query";
import http from "../../utils/http-common";

export function useAdminResetPassword() {
  return useMutation({
    mutationFn: (userId) => http.post(`/user/${userId}/reset-password`).then(res => res.data),
  });
}
